import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { MainLayoutComponentProps } from './MainLayoutComponent.tsx';

export const MainLayout: LoadableType<
	Pick<
		MainLayoutComponentProps,
		'children' | 'enableNavigation' | 'navView' | 'isViewPage' | 'isEdit' | 'editorPreloader'
	> & {
		spaceKey?: string;
	}
> = LoadablePaint({
	_reactTreeRootForServerPlaceholderId: true,
	name: 'MainLayout',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MainLayout" */ './MainLayout.tsx')).MainLayout,
});
